import { jsxs as d, Fragment as g, jsx as a } from "react/jsx-runtime";
import { useRef as u, useEffect as x } from "react";
import l from "dayjs";
import { useClose as w } from "@headlessui/react";
const C = ({ value: m, onChange: s, minutesStep: o }) => {
  const e = w(), f = Array.from({ length: 24 }).map(
    (r, t) => t.toString().padStart(2, "0")
  ), h = Array.from(
    { length: 60 / o },
    (r, t) => (t * o).toString().padStart(2, "0")
  ), i = (r, t) => {
    const n = m || l().format("HH:mm"), [p] = n.split(":"), c = t === "hours" ? `${r}` : `${p}:${r}`;
    s(c), c.length === 5 && e();
  };
  return /* @__PURE__ */ d(g, { children: [
    /* @__PURE__ */ a("div", { className: "jm-no-scrollbar jm-grid jm-max-h-72 jm-gap-2 jm-overflow-auto", children: f.map((r, t) => /* @__PURE__ */ a(
      j,
      {
        value: r,
        isSelected: r === (m || l().format("HH:mm")).split(":")[0],
        onChange: (n) => i(n, "hours")
      },
      r + t
    )) }),
    /* @__PURE__ */ a("div", { className: "jm-no-scrollbar jm-grid jm-max-h-72 jm-gap-2 jm-overflow-auto", children: h.map((r, t) => /* @__PURE__ */ a(
      j,
      {
        value: r,
        isSelected: r === (m || l().format("HH:mm")).split(":")[1],
        onChange: (n) => i(n, "minutes")
      },
      r + t
    )) })
  ] });
}, j = ({
  value: m,
  onChange: s,
  isSelected: o = !1
}) => {
  const e = u(null);
  return x(() => {
    e.current && o && e.current.scrollIntoView();
  }, []), /* @__PURE__ */ a(
    "div",
    {
      ref: e,
      onClick: () => s(m),
      className: `jm-font-paragraph-1 jm-h-fit jm-rounded-lg jm-px-2 jm-py-1.5 jm-text-center jm-text-jutro-new-warm-gray-800 hover:jm-bg-jutro-new-blue-700 hover:jm-text-white ${o ? "jm-bg-jutro-new-blue-700 jm-text-white" : ""}`,
      children: m
    }
  );
};
export {
  C as Picker
};
//# sourceMappingURL=Picker.js.map
